import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useHybridAuth } from './useHybridAuth';
import { driverApi } from '../services/driverApi';

export const useReportGoa = () => {
  const { getAccessTokenSilently } = useHybridAuth();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      dispatchId,
      goaReason,
      notes,
    }: {
      dispatchId: string;
      goaReason: string;
      notes?: string;
    }) => {
      const token = await getAccessTokenSilently();
      driverApi.setAuthToken(token);
      return driverApi.reportDispatchGoa(dispatchId, goaReason, notes);
    },
    onSuccess: (data, variables) => {
      // Invalidate and refetch driver calls to get updated data
      queryClient.invalidateQueries({ queryKey: ['driver-calls'] });

      // Also invalidate the specific call query that CallScreen is using
      queryClient.invalidateQueries({
        queryKey: ['driver-call', variables.dispatchId],
      });

      // Optionally, we could also invalidate all driver-call queries
      queryClient.invalidateQueries({ queryKey: ['driver-call'] });
    },
    onError: (error: any, variables, context) => {
      console.error('Failed to report GOA:', error);

      // Error will be handled by the component
      throw error;
    },
  });
};
